import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Page404Component } from './page404/page404.component';
import { JitsiComponent } from './pages/jitsi/jitsi.component';


const routes: Routes = [
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
  },
  // {
  //   path: 'editor',
  //   loadChildren: () => import('./editor/editor.module').then(m => m.EditorModule),
  // },
  {
    path: 'jitsi/:id',
    component: JitsiComponent
  },
  { path: 'page404', component: Page404Component },
  {
    path: '',
    loadChildren: () => import('./users/users.module').then(m => m.UsersModule),
  },
  { path: '**', redirectTo: ''}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
